import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, ViewEncapsulation, InjectionToken, EventEmitter, Optional, Inject, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@xpo-ltl/ngx-ltl-board';
import { XpoBoardApiDispatcherBase, XpoBoardConsumer, XpoBoardStateSources, XpoBoardData, XpoGridBoardView, XpoBoardViewTemplate, XpoBoardDataFetchState, XpoSortExpression, Operators, XpoColumnLevelFilteringToggleComponent, XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, XpoFiltersModule, XpoBoardModule } from '@xpo-ltl/ngx-ltl-board';
import * as merge from 'deepmerge';
import { isEqual, filter, difference, keys, isEmpty, omit, cloneDeep } from 'lodash-es';
import * as i2 from '@angular/material/checkbox';
import { MAT_CHECKBOX_DEFAULT_OPTIONS, MatCheckboxModule } from '@angular/material/checkbox';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@xpo-ltl/ngx-ltl-grid';
import { XPO_AG_GRID_DEFAULT_ROW_HEIGHT, XpoAgGridModule } from '@xpo-ltl/ngx-ltl-grid';
import * as i5 from 'ag-grid-angular';
import { AgGridModule } from 'ag-grid-angular';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { FormsModule } from '@angular/forms';

var XpoAgGridBoardApiAction;
(function (XpoAgGridBoardApiAction) {
    XpoAgGridBoardApiAction["FocusRow"] = "focusRow";
    XpoAgGridBoardApiAction["UpdateEditingState"] = "updateEditingState";
})(XpoAgGridBoardApiAction || (XpoAgGridBoardApiAction = {}));

class XpoAgGridBoardApi {
    constructor(agGridBoardApiDispatcher) {
        this.agGridBoardApiDispatcher = agGridBoardApiDispatcher;
    }
    focusRow(row) {
        this.agGridBoardApiDispatcher.executeAction(XpoAgGridBoardApiAction.FocusRow, row);
    }
    updateEditingState(isEditing, field) {
        this.agGridBoardApiDispatcher.executeAction(XpoAgGridBoardApiAction.FocusRow, isEditing, field);
    }
}

class XpoAgGridBoardApiDispatcherService extends XpoBoardApiDispatcherBase {
}
XpoAgGridBoardApiDispatcherService.ɵfac = /*@__PURE__*/ function () { let ɵXpoAgGridBoardApiDispatcherService_BaseFactory; return function XpoAgGridBoardApiDispatcherService_Factory(t) { return (ɵXpoAgGridBoardApiDispatcherService_BaseFactory || (ɵXpoAgGridBoardApiDispatcherService_BaseFactory = i0.ɵɵgetInheritedFactory(XpoAgGridBoardApiDispatcherService)))(t || XpoAgGridBoardApiDispatcherService); }; }();
XpoAgGridBoardApiDispatcherService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: XpoAgGridBoardApiDispatcherService, factory: XpoAgGridBoardApiDispatcherService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAgGridBoardApiDispatcherService, [{
        type: Injectable
    }], null, null); })();

class XpoAgGridFilterChipComponent {
    agInit(params) {
        this.filter = params.filter;
        this.criteriaStore = params.criteriaStore;
    }
    afterGuiAttached(params) { }
    onParentModelChanged(parentModel, filterChangedEvent) { }
}
XpoAgGridFilterChipComponent.ɵfac = function XpoAgGridFilterChipComponent_Factory(t) { return new (t || XpoAgGridFilterChipComponent)(); };
XpoAgGridFilterChipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAgGridFilterChipComponent, selectors: [["xpo-ag-grid-filter-chip"]], hostAttrs: [1, "xpo-AgGridFilterChip"], decls: 1, vars: 2, consts: [[1, "xpo-AgGridFilterChip-filter", 3, "filter", "criteriaStore"]], template: function XpoAgGridFilterChipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "xpo-filter-chip", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("filter", ctx.filter)("criteriaStore", ctx.criteriaStore);
    } }, directives: [i1.XpoFilterChip], styles: [".flex--stretch{flex:1}.xpo-AgGridFilterChip{align-items:center;display:inline-flex;width:100%}.xpo-AgGridFilterChip-filter.xpo-FilterChip{background-color:#fff;margin:0;width:100%}.xpo-AgGridFilterChip-filter.xpo-FilterChip .xpo-FilterChip-labelWrapper{overflow:hidden;text-overflow:ellipsis}.xpo-AgGridFilterChip-filter.xpo-FilterChip .xpo-FilterChip-labelPrefix{display:none}.xpo-AgGridFilterChip-filter.xpo-FilterChip .xpo-FilterChip-dropdownIcon{margin-left:auto}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAgGridFilterChipComponent, [{
        type: Component,
        args: [{
                selector: 'xpo-ag-grid-filter-chip',
                templateUrl: './ag-grid-filter-chip.component.html',
                styleUrls: ['./ag-grid-filter-chip.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: {
                    class: 'xpo-AgGridFilterChip',
                },
            }]
    }], null, null); })();

/**
 * This class assign behavior to the state of the custom selection created for ag-grid in server side
 */
class SelectAllState {
    constructor(keyField) {
        this.keyField = keyField;
        this.all = false;
        this.countOfSelect = 0;
        this.excluded = new Set();
        this.selection = new Set();
    }
    /**
     * Perform select all action cleaning selected and excluded sets
     */
    selectAll() {
        this.all = true;
        this.excluded.clear();
        this.selection.clear();
    }
    /**
     * Restore select all state to initial
     */
    reset() {
        this.all = false;
        this.selection.clear();
        this.excluded.clear();
        this.countOfSelect = 0;
    }
}

class XpoAgGridSelectAllCheckbox extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd) {
        super(boardDataSourceResolver, cd);
        this.SELECTION_CHANGE_SELECT_NAME = XpoBoardStateSources.SelectionChange;
        this.EVENT_SELECTION_CHANGED_NAME = 'selectionChanged';
        this.EVENT_PAGINATION_CHANGED_NAME = 'paginationChanged';
        this.EVENT_FILTER_CHANGED_NAME = 'filterChanged';
        this.CLIENT_SIDE_ID = 'clientSide';
        this.checked = false;
        this.indeterminate = false;
        this.cachedSelection = [];
        this.updateNodesNextTimePaginationChanges = false;
        this.selectionChangeListener = () => {
            if (!this.selectionChangedDispatchedByUs) {
                this.updateState();
                this.updateSelection();
            }
            this.selectionChangedDispatchedByUs = false;
        };
        this.paginationChangedListener = (event) => {
            /*
              On the first time paginationChangeListener is fired (event.newPage=true)
              the nodes are not yet rendered in the page
              so it doesn't make sense to try to select nodes now. That event is fired from ag-grid
              again when nodes are rendered
              (but with event.newPage=false) so we need to select them in the next time.
              Pagination change is fired also when filter changes
              (event.newPage=false) so we need to consider that as well and select new nodes only when they are already rendered
              and we are in a new page (not when new nodes comes from a filter change,
              in that case they need to remain unselected).
            */
            if (this.selectAllState.all && this.updateNodesNextTimePaginationChanges) {
                this.setNodesSelection(true, false);
                this.updateNodesNextTimePaginationChanges = false;
            }
            // Preparing to select nodes next time pagination change is fired and nodes are rendered.
            if (this.selectAllState.all && event.newPage) {
                this.updateNodesNextTimePaginationChanges = true;
            }
            // We need to update pagination state in case new nodes are ingested and select-all needs to switch to intermediate.
            if (!event.newPage) {
                this.updateSelection();
            }
        };
        this.filterChangedListener = (param) => {
            // TODO: Need to test this with server side and probably do some small refactor NGXLTL-912
            /**
             * This listener is dispatched with filters coming from the master grid or any of his child so the
             * following if statement compare the stored filters to detect if the changes comes from this grid or other.
             * If came from this, clear selection
             */
            const newFilters = param.api.getFilterModel();
            if (!isEqual(this.cachedFilters, newFilters)) {
                this.dispatchCustomEvent();
            }
            this.cachedFilters = newFilters;
            this.updateSelection();
        };
    }
    onStateChange(state) { }
    agInit(params) {
        this.gridApi = params.api;
        this.isDetailGrid = params.isDetailGrid;
        this.rowGroupingSelectable = params.rowGroupingSelectable;
        this.setKeyField(params.keyField);
        this.gridApi.addEventListener(this.EVENT_SELECTION_CHANGED_NAME, this.selectionChangeListener);
        this.gridApi.addEventListener(this.EVENT_PAGINATION_CHANGED_NAME, this.paginationChangedListener);
        this.gridApi.addEventListener(this.EVENT_FILTER_CHANGED_NAME, this.filterChangedListener);
        // We have to do this because ag-grid has different node iterators for
        // client-side and non client-side row model types
        this.nodeIteratorName =
            this.gridApi.getModel().getType() === this.CLIENT_SIDE_ID ? 'forEachNodeAfterFilter' : 'forEachNode';
        this.selectionChangeListener();
    }
    handleCheckboxChange() {
        this.selectionChangedDispatchedByUs = true;
        !this.checked || this.indeterminate ? this.selectAll() : this.unselectAll();
        this.dispatchCustomEvent();
    }
    refresh(params) {
        return !!params;
    }
    updateSelection() {
        // If all visible nodes are selected but not all data-set is selected, mark selected all checkbox
        if (this.areAllVisibleSelected()) {
            this.selectAllVisible();
            return;
        }
        // If all data-set is selected then go to select-all state
        if (this.isAllDataSetSelected()) {
            this.selectAll();
            return;
        }
        // If all visible nodes are blank then reset the select all checkbox
        if (this.areAllVisibleBlank()) {
            this.unselectAll();
            return;
        }
        // If not all nodes are blank, nor all dataset is selected, nor all visible nodes are selected,
        // then fallback to intermediate
        this.setToIndeterminate();
    }
    /**
     * Return true only if all data-set is selected
     */
    isAllDataSetSelected() {
        const totalRowsCount = this.getSelectableRowCount();
        const totalRowsSelected = this.cachedSelection.length;
        return totalRowsCount && totalRowsCount === totalRowsSelected;
    }
    /**
     * Return true if all visible nodes are selected
     */
    areAllVisibleSelected() {
        const totalRowsCount = this.getSelectableRowCount();
        if (!totalRowsCount) {
            return false;
        }
        let allVisibleSelected = true;
        // TODO: Unfortunately ag-grid does not provide a better use of the filtered nodes,
        //  need to do this old school stuff.
        let filteredNodesCount = 0;
        if (this.gridApi) {
            this.gridApi[this.nodeIteratorName]((node) => {
                filteredNodesCount++;
                if (!node.isSelected()) {
                    allVisibleSelected = false;
                }
            });
        }
        return allVisibleSelected && filteredNodesCount > 0;
    }
    /**
     * Return true if all visible nodes are not selected
     */
    areAllVisibleBlank() {
        let someIsSelected = false;
        if (this.gridApi) {
            this.gridApi[this.nodeIteratorName]((node) => {
                if (node.isSelected()) {
                    someIsSelected = true;
                }
            });
        }
        return !someIsSelected;
    }
    // It's not a performing method but is safer than keep a qty on init and update it when filters are applied
    getSelectableRowCount() {
        let count = 0;
        // Can't reduce this logic with a filter because is an ag-grid custom one
        this.gridApi.forEachNode((node) => {
            // Group and detail rows haven't data.
            // Can't check for selectable boolean because can be true even with no checkbox
            // Can't check for row type either because some row groups can have checkboxes
            if (node.data) {
                count++;
            }
        });
        return count;
    }
    dispatchCustomEvent() {
        const event = {
            type: this.EVENT_SELECTION_CHANGED_NAME,
            api: this.gridApi,
        };
        this.selectionChangedDispatchedByUs = true;
        this.gridApi.dispatchEvent(event);
    }
    setToIndeterminate() {
        this.checked = false;
        this.indeterminate = true;
        this.cd.markForCheck();
        this.emitSelectionChange();
    }
    setToChecked() {
        this.checked = true;
        this.indeterminate = false;
    }
    setToNoneSelected() {
        this.checked = false;
        this.indeterminate = false;
    }
    selectAll() {
        /** For Client Side Grid: select all only if no filters applied, Not modifing this behaviour,
         * however for server side select all should update the state for both cases, filter applied or not applied
         */
        if (!this.isClientSideGrid()) {
            this.selectAllState.selectAll();
        }
        else {
            if (!this.areFiltersApplied()) {
                this.selectAllState.selectAll();
            }
        }
        this.setNodesSelection(true, false);
        this.setToChecked();
        this.cd.markForCheck();
        this.emitSelectionChange();
    }
    isClientSideGrid() {
        return this.gridApi.getModel().getType() === this.CLIENT_SIDE_ID;
    }
    selectAllVisible() {
        this.setToChecked();
        this.cd.markForCheck();
        this.emitSelectionChange();
    }
    unselectAll() {
        this.setToNoneSelected();
        if (this.areFiltersApplied()) {
            this.unselectAllCurrentNodes();
        }
        else {
            this.selectAllState.reset();
            this.setNodesSelection(false, false);
        }
        this.cd.markForCheck();
        this.emitSelectionChange();
    }
    unselectAllCurrentNodes() {
        if (this.gridApi) {
            this.gridApi[this.nodeIteratorName]((node) => {
                node.setSelected(false);
            });
        }
    }
    areFiltersApplied() {
        var _a;
        return (this.cachedFilters && Object.keys(this.cachedFilters).length !== 0) || ((_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.isQuickFilterPresent());
    }
    /**
     * Assign new state to cached after check excluded ids for selection
     */
    updateState() {
        const agGridSelecteds = this.gridApi.getSelectedNodes();
        const newSelection = filter(agGridSelecteds, (node) => {
            return node.data !== undefined;
        });
        // Check isn't a massive un-selection. In that case remove the select all state and just left select the selected
        if (this.selectAllState.all && this.cachedSelection.length - newSelection.length <= 1) {
            this.updateExcluded(this.mapSelection(newSelection));
            this.selectAllState.selection.clear();
        }
        else {
            this.selectAllState.reset();
            // Add the new selection mapping only ID's with given keyField
            this.selectAllState.selection = new Set(newSelection.map((node) => node.data[this.selectAllState.keyField]));
        }
        this.cachedSelection = this.mapSelection(newSelection);
    }
    mapSelection(selection) {
        return selection.map((select) => select.data);
    }
    /**
     * In client-side: Performs the action of set each row filtered as selected if correspond.
     * In server-side: Performs the action of set each row as selected, not considering the filtered.
     * The second parameter allows to
     * cancel the ag-grid event emition for new selected.
     * @param setSelected
     * @param emitEvent
     */
    setNodesSelection(setSelected, emitEvent = true) {
        if (!this.gridApi || !this.gridApi[this.nodeIteratorName]) {
            return;
        }
        this.gridApi[this.nodeIteratorName]((node) => {
            var _a;
            // Avoiding updating the state `x` amount of times and only sending out
            // the selection change event on the last row.
            const emitSelectEvent = node.rowIndex === this.gridApi.getLastDisplayedRow() && emitEvent;
            const isNodeExcluded = this.selectAllState.excluded.has((_a = node.data) === null || _a === void 0 ? void 0 : _a.pickupRequestInstId);
            if ((node.data || (this.rowGroupingSelectable && node.group)) && !isNodeExcluded) {
                node.setSelected(setSelected, false, !emitSelectEvent);
            }
        });
        this.updateState();
    }
    /**
     * Toggles new excluded / added rows to excluded set in the state
     * @param selection
     */
    updateExcluded(selection) {
        if (selection.length < this.cachedSelection.length) {
            this.getDiffBetweenSelections(this.cachedSelection, selection).forEach((row) => {
                this.selectAllState.excluded.add(row[this.selectAllState.keyField]);
            });
        }
        else if (selection.length > this.cachedSelection.length) {
            this.getDiffBetweenSelections(selection, this.cachedSelection).forEach((row) => {
                this.selectAllState.excluded.delete(row[this.selectAllState.keyField]);
            });
        }
    }
    getDiffBetweenSelections(sel1, sel2) {
        return sel1.filter((node) => !sel2.some((otherNode) => node[this.selectAllState.keyField] === otherNode[this.selectAllState.keyField]));
    }
    updateCountOfSelect() {
        const countRowsSelected = this.cachedSelection.length;
        const countTotalRows = this.gridApi.getDisplayedRowCount();
        this.selectAllState.countOfSelect = this.selectAllState.all
            ? countTotalRows - this.selectAllState.excluded.size
            : countRowsSelected;
    }
    /**
     * Emits the advice of selection change for all the app. This method is called only from
     * selectionChangeListener or handleCheckboxChange, the two ways where user can change selection
     */
    emitSelectionChange() {
        this.updateCountOfSelect();
        // The board state isn't prepared yet to receive a selection change from a grid detail. It'll be developed soon
        if (!this.isDetailGrid) {
            this.stateChange$.next({
                selection: this.cachedSelection,
                source: this.SELECTION_CHANGE_SELECT_NAME,
                customSelection: this.selectAllState,
            });
        }
    }
    setKeyField(keyField) {
        if (!keyField) {
            const keyFieldProperty = this.isDetailGrid ? 'detailGridKeyField' : 'keyField';
            console.error(`[XPO-LTL-BOARD] ${keyFieldProperty} property should be defined in your XpoAgGridBoardViewTemplate options if you want to use the select all checkbox`);
        }
        this.selectAllState = new SelectAllState(keyField);
    }
    ngOnDestroy() {
        this.gridApi.removeEventListener(this.EVENT_PAGINATION_CHANGED_NAME, this.paginationChangedListener);
        this.gridApi.removeEventListener(this.EVENT_SELECTION_CHANGED_NAME, this.selectionChangeListener);
        this.gridApi.removeEventListener(this.EVENT_FILTER_CHANGED_NAME, this.filterChangedListener);
    }
}
XpoAgGridSelectAllCheckbox.ɵfac = function XpoAgGridSelectAllCheckbox_Factory(t) { return new (t || XpoAgGridSelectAllCheckbox)(i0.ɵɵdirectiveInject(i1.XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoAgGridSelectAllCheckbox.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAgGridSelectAllCheckbox, selectors: [["xpo-ag-grid-paginated-select-all-checkbox"]], hostAttrs: ["data-cy", "select-all-checkbox", 1, "xpo-AgGridPaginatedSelectAllCheckbox"], features: [i0.ɵɵProvidersFeature([
            { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } },
        ]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 2, consts: [[3, "checked", "indeterminate", "click"]], template: function XpoAgGridSelectAllCheckbox_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-checkbox", 0);
        i0.ɵɵlistener("click", function XpoAgGridSelectAllCheckbox_Template_mat_checkbox_click_0_listener() { return ctx.handleCheckboxChange(); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("checked", ctx.checked)("indeterminate", ctx.indeterminate);
    } }, directives: [i2.MatCheckbox], styles: [".flex--stretch{flex:1}.xpo-AgGridPaginatedSelectAllCheckbox{display:flex;padding:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox{cursor:inherit;margin:0;padding:0;transition:unset}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox .mat-checkbox-inner-container{margin:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox .mat-checkbox-frame{border:none}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-background{transition:unset;background:url('data:image/svg+xml;utf8,<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path fill=\"%23171717\" fill-rule=\"nonzero\" d=\"M26.252 0c3.173 0 5.748 2.576 5.748 5.749v20.503c0 3.173-2.576 5.748-5.748 5.748h-20.503c-3.173 0-5.749-2.576-5.749-5.748v-20.503c0-3.173 2.576-5.749 5.749-5.749h20.503zM26.313 2.229h-20.597c-1.893 0-3.431 1.538-3.431 3.433v20.597c0 1.893 1.538 3.431 3.431 3.431h20.597c1.895 0 3.433-1.538 3.433-3.431v-20.597c0-1.895-1.538-3.433-3.433-3.433z\"></path></svg>') no-repeat;background-color:transparent;background-position:center;background-repeat:no-repeat;background-size:10px 10px;color:transparent;height:10px;width:10px;background-size:14px 14px;height:14px;width:14px}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-checked .mat-checkbox-background{background:url('data:image/svg+xml;utf8,<svg fill=\"%23171717\" fill-rule=\"nonzero\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 32 32\"><path d=\"M26.252 32h-20.503c-3.173 0-5.749-2.576-5.749-5.748v-20.503c0-3.173 2.576-5.749 5.749-5.749h20.503c3.173 0 5.748 2.576 5.748 5.749v20.503c0 3.173-2.576 5.748-5.748 5.748zM26.313 2.229h-20.597c-1.893 0-3.431 1.538-3.431 3.433v20.597c0 1.893 1.538 3.431 3.431 3.431h20.597c1.895 0 3.433-1.538 3.433-3.431v-20.597c0-1.895-1.538-3.433-3.433-3.433zM25.952 9.952l-13.381 13.378-6.523-6.521 1.618-1.618 4.905 4.907 11.762-11.765c0.539 0.539 1.079 1.079 1.618 1.618z\"></path></svg>') no-repeat;background-color:transparent;background-position:center;background-repeat:no-repeat;background-size:10px 10px;color:transparent;height:10px;width:10px;background-size:14px 14px;height:14px;width:14px}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-checked .mat-checkbox-checkmark{fill:transparent;opacity:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-indeterminate .mat-checkbox-background{background:url('data:image/svg+xml;utf8,<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\"><path d=\"M26.252 32h-20.503c-3.173 0-5.749-2.576-5.749-5.748v-20.503c0-3.173 2.576-5.749 5.749-5.749h20.503c3.173 0 5.748 2.576 5.748 5.749v20.503c0 3.173-2.576 5.748-5.748 5.748zM26.313 2.229h-20.597c-1.893 0-3.431 1.538-3.431 3.433v20.597c0 1.893 1.538 3.431 3.431 3.431h20.597c1.895 0 3.433-1.538 3.433-3.431v-20.597c0-1.895-1.538-3.433-3.433-3.433zM25.143 17.143h-18.286v-2.286h18.286v2.286z\"></path></svg>') no-repeat;background-color:transparent;background-position:center;background-repeat:no-repeat;background-size:10px 10px;color:transparent;height:10px;width:10px;background-size:14px 14px;height:14px;width:14px}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-indeterminate .mat-checkbox-checkmark{fill:transparent;opacity:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-indeterminate .mat-checkbox-inner-container{border:none}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-indeterminate .mat-checkbox-inner-container .mat-checkbox-background{border:none;margin:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-mixedmark{background:transparent;fill:transparent;opacity:0}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-checkmark{fill:transparent}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-checkmark-path{stroke:transparent!important}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox-frame{transition:none}.xpo-AgGridPaginatedSelectAllCheckbox .mat-checkbox:not(.mat-checkbox-disabled) .mat-checkbox-inner-container:hover{background:inherit}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAgGridSelectAllCheckbox, [{
        type: Component,
        args: [{
                selector: 'xpo-ag-grid-paginated-select-all-checkbox',
                templateUrl: 'ag-grid-select-all.component.html',
                styleUrls: ['ag-grid-select-all.component.scss'],
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: { class: 'xpo-AgGridPaginatedSelectAllCheckbox', 'data-cy': 'select-all-checkbox' },
                providers: [
                    { provide: MAT_CHECKBOX_DEFAULT_OPTIONS, useValue: { clickAction: 'noop' } },
                ],
            }]
    }], function () { return [{ type: i1.XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }]; }, null); })();

const XPO_BOARD_AG_GRID_DEFAULT_GRID_OPTIONS = new InjectionToken('XpoBoardAgGridDefaultOptions');

class XpoAgGridBoardDatum {
    constructor(boardData) {
        this.totals = null;
        if (boardData instanceof Array) {
            this.rows = boardData;
        }
        else {
            this.columns = boardData.columns;
            this.rows = boardData.rows;
            this.totals = boardData.totals;
        }
    }
}
class XpoAgGridBoardData extends XpoBoardData {
    constructor(data) {
        super(data.state, new XpoAgGridBoardDatum(data.consumerData || []), data.recordCount, data.pageSize);
    }
}

class XpoAgGridBoardView extends XpoGridBoardView {
    constructor(template, config) {
        super(template, config);
    }
}
class XpoAgGridBoardViewTemplate extends XpoBoardViewTemplate {
    constructor(config) {
        super(config);
        this.availableColumns = config.availableColumns || [];
    }
    createView(config) {
        this.assignUniqueId(config);
        return new XpoAgGridBoardView(this, Object.assign({ templateId: this.id }, config));
    }
}

// assists with replaying requests to avoid multiple requests to the server for the same data
class GridDataReplayCache {
    constructor() {
        this.cachedData = null;
        this.rangeHash = null;
        this.sortHash = null;
        this.wasLastRequestForSortingValue = false;
    }
    static getGridCallbackRangeHash(data) {
        // generate a hash representing the request
        return JSON.stringify({
            endRow: data.params['endRow'],
            startRow: data.params['startRow'],
        });
    }
    // generates a hash key of the grid sort parameters
    static getGridCallbackSortHash(data) {
        // generate a hash representing the request
        return JSON.stringify({
            sortModel: data.params['sortModel'],
        });
    }
    get wasLastRequestForSorting() {
        return this.wasLastRequestForSortingValue;
    }
    clear() {
        this.cachedData = null;
        this.rangeHash = null;
        this.sortHash = null;
        this.wasLastRequestForSortingValue = false;
    }
    get(callbackData) {
        let result = null;
        if (this.cachedData &&
            this.cachedData.state.viewId === callbackData.view.id &&
            this.sortHash === GridDataReplayCache.getGridCallbackSortHash(callbackData) &&
            this.rangeHash === GridDataReplayCache.getGridCallbackRangeHash(callbackData)) {
            result = this.cachedData;
        }
        return result;
    }
    set(callbackData, data) {
        const hashKey = GridDataReplayCache.getGridCallbackSortHash(callbackData);
        this.wasLastRequestForSortingValue =
            this.cachedData !== null && this.cachedData.state.viewId === data.state.viewId && this.sortHash !== hashKey;
        this.cachedData = data;
        this.rangeHash = GridDataReplayCache.getGridCallbackRangeHash(callbackData);
        this.sortHash = hashKey;
    }
}

class XpoAgGridBoardReadyEvent {
}

class XpoColumnsHelper {
    /**
     * General logic to find and update the column in the original column definition
     * to keep the necessary properties updated when some action is performed on the grid
     * @param event General column event received from ag-grid event
     * @param action Action to perform regarding the necessary update of column def
     * @param columns The set of columns to be updated
     * @returns The updated set of columns after perform the action received over each affected column
     */
    static onGeneralColumnEvent(event, action, columns) {
        // Flag to avoid emitting unnecessary changes
        let isColDefChanged = false;
        // Iterate each received column in the event. Column with changes according ag-grid
        event.columns.forEach((updatedColumn) => {
            // Get the reference of it in our columnDefinition with its ID
            const colDef = XpoColumnsHelper.getColRef(updatedColumn.getColId(), columns);
            if (colDef) {
                // Perform the action received sending the colDef and the current column updated
                action(colDef, updatedColumn);
                isColDefChanged = true;
            }
        });
        // If no changes were done return null
        return isColDefChanged ? columns : null;
    }
    /**
     * This method uses a diff logic than the onGeneralColumnEvent
     * because we need to map and re-build the columnDef defined by the user
     * keeping it as a XpoAgGridBoardColumn type to be saved in the new view.
     * Here we map the columnState obtained from ag-grid with the original
     * columnDef set on the implementation.
     * @param event ColumnMovedEvent returned by ag-grid
     * @param columns The set of columns to be updated
     * @returns The new reordered set of columns
     */
    static onColumnMovedEvent(event, columns) {
        // Get the ag-grid columnState with the current state
        const columnsState = event.columnApi.getColumnState();
        // Create the new XpoAgGridBoardColumn container
        const newColumns = [];
        // Iterate each ag-grid column state
        columnsState.forEach((colState) => {
            // Get the original colDef matching the colId
            const colInDef = XpoColumnsHelper.getColRefWithUniqueChildren(colState.colId, columns);
            if (colInDef) {
                // Push to the new container in the current order
                newColumns.push(colInDef);
            }
        });
        // As ag-grid returns the children separated we have to merge them
        // to match our XpoAgGridBoardColumn expected structure
        return XpoColumnsHelper.mergeConsecutiveParents(newColumns);
    }
    /**
     * Returns a column obtained in a set of them but removing its
     * children leaving just the one we are looking for in this case.
     * This is necessary due the structure of data that ag-grid gave
     * to us where al the children and parents are in the same level.
     * TODO: Recursive children - NGXLTL-XXX
     * @param searchedId The id we need to find in the dataset
     * @param origin The original dataset where we are searching
     * @returns Returns the a new colDef obtained from the origin but edited
     */
    static getColRefWithUniqueChildren(searchedId, origin) {
        // Iterate first level searching among parent columns
        let searchedColumn = XpoColumnsHelper.getColByColIdOneLevel(searchedId, origin);
        // If not found search in children columns
        if (!searchedColumn) {
            // Iterate each parent accessing their children
            searchedColumn = origin.find(({ children }) => {
                // Iterate each child searching the ID. If found return the parent
                return XpoColumnsHelper.getColByColIdOneLevel(searchedId, children);
            });
            // If parent was found. Remove children but the current child.
            // We're going to have this parent for each children so then
            // We merge (consecutive) parents into one avoiding having repeated children
            if (searchedColumn && !!searchedColumn.children) {
                // Cloning the col def because we are going to remove some columns
                // And we don't want to alter the original reference
                const clonedColumnDef = Object.assign({}, searchedColumn);
                clonedColumnDef.children = clonedColumnDef.children.filter((child) => child.colId === searchedId);
                searchedColumn = clonedColumnDef;
            }
        }
        return searchedColumn;
    }
    /**
     * Merge consecutive parents with the same colId
     * @param columns Set of columns
     * @returns A new set of columns where consecutive parents were merged into one
     */
    static mergeConsecutiveParents(columns) {
        for (let i = 0; i < columns.length - 1; i++) {
            for (let j = i + 1; j < columns.length; j++) {
                // If the next column also has children and the same groupId
                if (columns[i].children &&
                    columns[j].children &&
                    columns[i].groupId &&
                    columns[j].groupId &&
                    columns[i].groupId === columns[j].groupId) {
                    // Take the second column child and push into current column, delete the second column
                    columns[i].children.push(columns[j].children[0]);
                    columns.splice(j--, 1);
                }
                else {
                    break;
                }
            }
        }
        return columns;
    }
    /**
     * Looks for a col reference in the first level of the dataset
     * and through its children just one level.
     * Default using col id, with third param can use headerName
     * TODO: Recursive children - NGXLTL-XXX
     * @param searchedId The searched col id
     * @param origin Dataset where look for
     * @param useHeaderName false by default. If true uses headerName in place of colId
     * @returns Returns the col reference or undefined
     */
    static getColRef(searchedId, origin, useHeaderName = false) {
        let searchMethod = XpoColumnsHelper.getColByColIdOneLevel;
        if (useHeaderName) {
            searchMethod = XpoColumnsHelper.getColByHeaderNameOneLevel;
        }
        // Iterate first level searching among parent columns
        let searchedColumn = searchMethod(searchedId, origin);
        // If not found search in children columns
        if (!searchedColumn) {
            // Iterate each parent accessing their children. If some child if found, stop iteration
            origin.some(({ children }) => {
                // Iterate each child searching the ID
                return (searchedColumn = searchMethod(searchedId, children));
            });
        }
        // If no column was found in parents and children (first level) return undefined
        return searchedColumn;
    }
    /**
     * Looks for a col reference in the first level of a dataset.
     * This column was abstracted to allow many methods to use it.
     * @param searchedId The searched col id
     * @param origin Dataset where look for
     * @returns Returns the col reference or undefined
     */
    static getColByColIdOneLevel(searchedId, origin) {
        // If origin is defined, search inside
        return origin && searchedId && origin.find((col) => col.colId && col.colId === searchedId);
    }
    /**
     * Looks for a col reference in the first level of a dataset.
     * This column was abstracted to allow many methods to use it.
     * @param searchedHeaderName The searched col id
     * @param origin Dataset where look for
     * @returns Returns the col reference or undefined
     */
    static getColByHeaderNameOneLevel(searchedHeaderName, origin) {
        // If origin is defined, search inside
        return (origin &&
            searchedHeaderName &&
            origin.find((col) => col.headerName && col.headerName === searchedHeaderName));
    }
    static isColGroupDef(column) {
        var _a;
        return !!((_a = column.children) === null || _a === void 0 ? void 0 : _a.length);
    }
    /**
     * Iterates each column on a given dataset and if col id is not defined assigns
     * some custom value
     * @param columns Dataset of columns to check
     * @param parentId (Optional) Given parent id
     * @returns Return a dataset of XpoAgGridBoardColumn with col id on each column
     */
    static addIdsToColumns(columns, parentId) {
        columns.forEach((col, index) => {
            if (XpoColumnsHelper.isColGroupDef(col)) {
                if (!col.groupId) {
                    col.groupId = `group_${index}`;
                }
                col.children = XpoColumnsHelper.addIdsToColumns(col.children, col.groupId);
            }
            else {
                if (!col.colId) {
                    col.colId = parentId ? `${parentId}_custom_${index}` : `id_${index}`;
                }
            }
        });
        return columns;
    }
}

function XpoAgGridBoard_xpo_ag_grid_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "xpo-ag-grid", 1);
    i0.ɵɵelement(1, "ag-grid-angular", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.highlightModeClass)("rowHeight", ctx_r0.rowHeight)("autoSizeColumns", ctx_r0.autoSizeColumns)("sizeColumnsToFit", ctx_r0.sizeColumnsToFit)("selectionMode", ctx_r0.selectionMode);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("gridOptions", ctx_r0.gridOptions);
} }
var XpoAgGridHighlightModeClasses;
(function (XpoAgGridHighlightModeClasses) {
    XpoAgGridHighlightModeClasses["row"] = "xpo-AgGrid--highlightModeRow";
    XpoAgGridHighlightModeClasses["cell"] = "xpo-AgGrid--highlightModeCell";
})(XpoAgGridHighlightModeClasses || (XpoAgGridHighlightModeClasses = {}));
class XpoAgGridBoard extends XpoBoardConsumer {
    constructor(boardDataSourceResolver, cd, agGridBoardApiDispatcher, filtersService, globalAgGridOptions) {
        super(boardDataSourceResolver, cd);
        this.agGridBoardApiDispatcher = agGridBoardApiDispatcher;
        this.filtersService = filtersService;
        this.globalAgGridOptions = globalAgGridOptions;
        this.GRID_ROW_INDEX_CLASS = 'xpo-AgGrid-rowIndexColumn';
        this.gridOptions = {};
        /** Used to recreate the board component when updating row heights when grid is set to infinite */
        this.gridVisible = true;
        this.highlightModeClass = XpoAgGridHighlightModeClasses.cell;
        this.columns = [];
        this.columnsFromDataSource = [];
        this.cachedAgGridFilterModel = {};
        this.frameworkComponents = { xpoAgGridFilterChipComponent: XpoAgGridFilterChipComponent };
        this.showFloatingFilters = false;
        this.dataAlreadyRendered = false;
        this.autoSelectFirstRowValue = false;
        this.autoSizeColumnsValue = false;
        this.enableMovableColumnsValue = false;
        this.enableCellSelectionValue = false;
        this.enableRowSelectionValue = true;
        this.enableSortingValue = false;
        this.groupUseEntireRowValue = false;
        this.sizeColumnsToFitValue = false;
        /** Whether to allow or single or multiple row select */
        this.rowSelection = 'single';
        /**
         * Sets the row model, options are 'client-side' client rendering and 'infinite' for server rendering.
         * Defaults to 'infinite'
         */
        this.rowModelType = 'infinite';
        this.selectionModeValue = 'row';
        this.suppressUsingRecordCountValue = false;
        /** Emits event when cell is clicked */
        this.cellSelected = new EventEmitter();
        /** TODO: this should be removed at the next major release in favor of gridBoardReady*/
        this.gridReady = new EventEmitter();
        this.gridBoardReady = new EventEmitter();
        this.refreshPagination = new EventEmitter();
        this.gridBoardApi = new XpoAgGridBoardApi(this.agGridBoardApiDispatcher);
    }
    /** Whether or not the first grid row is automatically selected
     * TODO: re implement
     */
    get autoSelectFirstRow() {
        return this.autoSelectFirstRowValue;
    }
    set autoSelectFirstRow(value) {
        this.autoSelectFirstRowValue = coerceBooleanProperty(value);
    }
    /*
     * Whether or not the columns are automatically auto-sized every-time data changes
     * TODO: reimplement
     */
    get autoSizeColumns() {
        return this.autoSizeColumnsValue;
    }
    set autoSizeColumns(value) {
        this.autoSizeColumnsValue = coerceBooleanProperty(value);
    }
    /** Whether or not you can move columns */
    get enableMovableColumns() {
        return this.enableMovableColumnsValue;
    }
    set enableMovableColumns(value) {
        this.enableMovableColumnsValue = coerceBooleanProperty(value);
    }
    /** Whether or not you can select a cell */
    get enableCellSelection() {
        return this.enableCellSelectionValue;
    }
    set enableCellSelection(value) {
        this.enableCellSelectionValue = coerceBooleanProperty(value);
    }
    /** Whether or not you can select a row */
    get enableRowSelection() {
        return this.enableRowSelectionValue;
    }
    set enableRowSelection(value) {
        this.enableRowSelectionValue = coerceBooleanProperty(value);
    }
    /** Whether or not the grid has sorting */
    get enableSorting() {
        return this.enableSortingValue;
    }
    set enableSorting(value) {
        this.enableSortingValue = coerceBooleanProperty(value);
    }
    /*
     * Whether or not grid uses the option groupUseEntireRow
     * TODO: re-implement
     */
    get groupUseEntireRow() {
        return this.groupUseEntireRowValue;
    }
    set groupUseEntireRow(value) {
        this.groupUseEntireRowValue = coerceBooleanProperty(value);
    }
    /*
     * Whether or not the columns are automatically sizedToFit every-time data changes or the screen is resized
     * TODO: re-implement
     */
    get sizeColumnsToFit() {
        return this.sizeColumnsToFitValue;
    }
    set sizeColumnsToFit(value) {
        this.sizeColumnsToFitValue = coerceBooleanProperty(value);
    }
    get gridApi() {
        return this.gridOptions.api;
    }
    get columnApi() {
        return this.gridOptions.columnApi;
    }
    /** Sets the selection mode, options are 'row' selection  and 'cell' selection. Defaults to 'row'  */
    get selectionMode() {
        return this.selectionModeValue;
    }
    set selectionMode(value) {
        this.selectionModeValue = value;
        if (this.selectionMode === 'row') {
            this.gridOptions.suppressRowClickSelection = false;
            this.gridOptions.suppressCellSelection = true;
        }
        else {
            this.gridOptions.suppressRowClickSelection = true;
            this.gridOptions.suppressCellSelection = false;
        }
    }
    /**
     * If true and set to infinite scroll, instead of virtualizing the rows using the record count coming from the
     * data source, it will only render the page size amount. When the user scrolls down to the bottom, it will then
     * fetch the next page and render the rows.
     */
    get suppressUsingRecordCount() {
        return this.suppressUsingRecordCountValue;
    }
    set suppressUsingRecordCount(value) {
        this.suppressUsingRecordCountValue = coerceBooleanProperty(value);
    }
    set highlightMode(value) {
        // Default to cell if the given mode doesn't exist
        if (!XpoAgGridHighlightModeClasses[value]) {
            console.warn(`[XPO-LTL-BOARD] Highlight mode "${value}" is not valid, defaulting to 'cell'. Available values: "row", "cell".`);
        }
        this.highlightModeClass = XpoAgGridHighlightModeClasses[value] || XpoAgGridHighlightModeClasses.cell;
    }
    ngOnInit() {
        super.ngOnInit();
        this.initializePagination();
        this.initializeGridOptions();
        this.registerBoardApiHandlers();
        // initialize if there is some column filter, if floating filters are active
        // and trigger an state update event needed to show or hide floating filters header row
        this.initializeColumnLevelFilteringVisibleState();
    }
    initializePagination() {
        if (!this.pagination) {
            return;
        }
        this.pagination.configurePageSettings(this.paginationPageSizes, this.paginationPageSizeStart);
        if (this.rowModelType !== 'client-side') {
            this.updatePaginationPageSize(this.pagination.currentPageSize);
            this.pagination.pageSizeChange.subscribe((pageSize) => {
                this.updatePaginationPageSize(pageSize);
                // ag-grid cache needs to be refreshed when pageSize changes on run time.
                this.gridOptions.api.refreshInfiniteCache();
            });
        }
    }
    onGridReady(params) {
        this.isGridReady = true;
        if (this.pendingStateUpdate) {
            this.applyStateUpdate(this.pendingStateUpdate);
            this.pendingStateUpdate = null;
        }
        this.gridReady.emit(params);
        this.gridBoardReady.emit({
            agGridApi: params.api,
            agGridColumnApi: params.columnApi,
            agGridBoardApi: this.gridBoardApi,
        });
        if (this.pagination) {
            this.pagination.initialize(params.api);
        }
    }
    /**
     * Update current pagination page size
     * @param pageSize
     */
    updatePaginationPageSize(pageSize) {
        // We must to update datasouce.page size which is used to calculate range and also need to persist it to
        // cacheBlockSize which is used by ag-grid to create rows to host new data.
        this.boardDataSourceResolver.dataSource.pageSize = pageSize;
        this.gridOptions.cacheBlockSize = pageSize;
    }
    /**
     * Check for checkboxSelection on the given columns and its children and return the column
     * @param columns
     */
    findCheckboxSelectionColumn(columns) {
        /**
         * Since ag-grid columns can either be ColDef or ColGroupDef and we need to use one attribute
         * from each independently we got to define this mixed type to avoid defining a new one.
         */
        return (columns.find((column) => {
            if (column.children) {
                return this.findCheckboxSelectionColumn(column.children);
            }
            return column.checkboxSelection === true;
        }) || null);
    }
    onCellClicked(event) {
        const selectedCell = {
            columnName: event.colDef.field,
            columnValue: event.value,
            rowIndex: event.rowIndex,
            rowData: event.data,
        };
        const stateChangeEvent = {
            focusedRecord: this.selectionMode === 'cell' ? selectedCell : selectedCell.rowData,
            source: XpoBoardStateSources.CellClicked,
        };
        // Publish state selection also
        if (this.selectionMode === 'cell') {
            stateChangeEvent.selection = [selectedCell];
        }
        else {
            const selectedNodes = event.api.getSelectedNodes() || [];
            stateChangeEvent.selection = selectedNodes.map((node) => node.data);
        }
        this.stateChange$.next(stateChangeEvent);
    }
    onSortChanged() {
        // if gridApi is not initialized we can't read the sort so nothing to do
        if (!this.gridApi) {
            return;
        }
        // if the sort didn't change, don't re-broadcast, it might have just
        // ended up here because we set the sort on initial load
        const gridSortModel = this.getSortModel();
        if (this.cachedState) {
            const mapStateSortOrder = this.generateSortOrderFromState(this.cachedState).filter((col) => col.sort);
            if (gridSortModel && JSON.stringify(mapStateSortOrder) === JSON.stringify(gridSortModel)) {
                return;
            }
        }
        this.pendingSortApply = true;
        const columnSorted = gridSortModel.map((sort) => {
            return { column: sort.colId, direction: sort.sort };
        });
        this.stateChange$.next({
            sortOrder: columnSorted,
            source: 'SORT-CHANGE',
        });
    }
    onStateChange(state) {
        if (state.changes.includes('data') && state.data) {
            state = Object.assign(Object.assign({}, state), { data: new XpoAgGridBoardData(state.data) });
        }
        this.applyStateUpdate(state);
    }
    isRowHeightUpdateRequired(state, rowModelType) {
        var _a;
        return (state.changes &&
            state.changes.includes('rowHeight') &&
            state.rowHeight &&
            state.rowHeight !== ((_a = this.cachedState) === null || _a === void 0 ? void 0 : _a.rowHeight) &&
            this.rowModelType === rowModelType);
    }
    // TODO: clean this up
    applyStateUpdate(state) {
        if (!this.gridApi || !this.isGridReady) {
            // for the case multiple pending states updates, we want to save all the changes that happened.
            this.pendingStateUpdate = Object.assign(Object.assign({}, state), { changes: this.pendingStateUpdate ? [...this.pendingStateUpdate.changes, ...state.changes] : state.changes });
            // Removing dupes
            this.pendingStateUpdate.changes = Array.from(new Set(this.pendingStateUpdate.changes));
            return;
        }
        /**
         * If row-height is required in inifinte row model we need to wait for the grid to be built again before
         * trying to apply any other state changes since it destroys the grid completely and re-creates it.
         */
        // TODO: Make enum for 'inifinite' and 'client-side' row models. NGXLTL-813
        if (this.isRowHeightUpdateRequired(state, 'infinite')) {
            // Persist state changes in pendingStateUpdate
            // which be handled once grid is recreated  after applyRowHeightUpdate is done
            this.pendingStateUpdate = Object.assign(Object.assign({}, this.pendingStateUpdate), state);
            this.applyRowHeightUpdate(state);
            return;
        }
        if (this.isRowHeightUpdateRequired(state, 'client-side')) {
            this.applyRowHeightUpdate(state);
        }
        // At this point, ensure that there is no pending state update since the gridApi is loaded.
        this.pendingStateUpdate = null;
        this.cachedState = state; // Storing state to be referred back to
        const viewTemplate = state.template;
        const viewTemplateKey = viewTemplate ? viewTemplate.keyField : null;
        let updateGridColumns = false; // Flag to call configureGridColumns()
        // Handling Template Changes
        if (state.changes.includes('template')) {
            // Update the getRowNodeId callback to fetch the ID from the template key
            if (viewTemplateKey) {
                this.gridOptions.getRowNodeId = (data) => data[viewTemplateKey];
            }
            else if (this.gridOptions.getRowNodeId) {
                this.gridOptions.getRowNodeId = null;
            }
        }
        // If there is a change in columns, update the grid columns.
        if (!isEqual(state.visibleColumns, this.columns) || state.source === 'ACTIVE-VIEW-CHANGE') {
            this.columns = state.visibleColumns || [];
            updateGridColumns = true;
        }
        // If there are some columns coming from the datasource, append them to the end of the list
        // TODO: maybe implement column ordering?
        if (state.changes.includes('data') &&
            state.data &&
            state.data.consumerData.columns &&
            state.data.consumerData.columns !== this.columnsFromDataSource) {
            this.columnsFromDataSource = state.data.consumerData.columns || [];
            updateGridColumns = true;
        }
        else if (state.dataFetchState === XpoBoardDataFetchState.Loading) {
            // Make sure we don't append some old cached data source columns
            this.columnsFromDataSource = [];
        }
        if (updateGridColumns) {
            // after any change in columns definition
            // apply new configuration for gridApi and gridOptions
            this.addColumnLevelFilters();
            this.configureGridColumns();
        }
        // Handle data changes
        const isViewChangeFetch = state.changes.includes('dataFetchState') && state.changes.includes('viewId');
        if (state.changes.includes('data') || isViewChangeFetch) {
            this.applyStateUpdateToData(state);
        }
        // handle selection when there are actually records to select
        if (state.changes.includes('selection') && state.source !== XpoBoardStateSources.SelectionChange && state.data) {
            // If selection comes in with an empty array or null, clear selection from grid
            if (!state.selection || !state.selection.length) {
                this.gridApi.deselectAll();
                this.gridApi.clearFocusedCell();
            }
            else if (state.data) {
                // In order to perform row selection we need to make sure we have a valid key set
                if (!viewTemplateKey) {
                    // TODO: this should throw an error, but we will need to call the error callback for ag-grid
                    // if you throw an error here, pagination is broken
                    console.error(`View template ${viewTemplate.name} has a null keyField value.
            Please provide the key of the field that uniquely identifies each row for this viewTemplate
            in order for some functionality of the ag-grid-board to work`);
                    return;
                }
                // Else, if there are selected rows, select them on the grid and make sure they are in focus
                let foundSelectCount = 0;
                // loop through each node and select it, if available
                this.gridApi.forEachNode((node) => {
                    if (state.selection.some((s) => node.data && s && s[viewTemplateKey] === node.data[viewTemplateKey] && this.rowModelType !== 'infinite')) {
                        node.setSelected(true, foundSelectCount === 0);
                        if (state.source !== XpoBoardStateSources.CellClicked) {
                            this.gridApi.ensureNodeVisible(node, null);
                        }
                        foundSelectCount++;
                    }
                });
            }
        }
        // handle initial load of saved sort
        if (state.changes.includes('sortOrder')) {
            this.applySortStateUpdate(state);
        }
        // if floating filters header rows visibility has changed
        if (state.changes.includes('columnLevelFilteringVisible')) {
            // hide or show floating filters header row based on actual value and configuration ones
            this.applyColumnFiltersVisibility(state.columnLevelFilteringVisible);
        }
        const keysMissingToUpdate = difference(keys(this.cachedAgGridFilterModel), keys(state.criteria));
        const updateFilters = !isEmpty(keysMissingToUpdate);
        if (updateFilters) {
            const newFilterModel = omit(this.cachedAgGridFilterModel, keysMissingToUpdate);
            this.gridApi.setFilterModel(newFilterModel);
        }
        // Assign state criteria values to ag-grid column filters if they exists
        if (state.changes.includes('criteria')) {
            this.loadCriteriaIntoColumnFilters(state.criteria);
            // [CustomSelection] clear selection if filter is applied
            if (this.rowModelType === 'infinite' && state.customSelection) {
                this.gridApi.deselectAll();
            }
        }
        // Enables/Disable editing
        if (state.changes.includes('isEditing')) {
            // TODO: Check if there are editable columns
            const editableColumn = state.visibleColumns.find((x) => !!x.editable);
            this.updateEditingState(state.isEditing, editableColumn.field);
        }
    }
    /**
     *
     * @param state
     */
    applySortStateUpdate(state) {
        if (!this.gridApi) {
            return;
        }
        const mapStateSortOrder = this.generateSortOrderFromState(state).filter((col) => col.sort);
        const gridSortModel = this.getSortModel();
        if (gridSortModel && JSON.stringify(mapStateSortOrder) !== JSON.stringify(gridSortModel)) {
            // Get the current column state
            const columnsState = this.columnApi.getColumnState();
            // Iterate columns that defines sorting
            mapStateSortOrder.forEach((sortDef) => {
                var _a;
                // Get the column ref from the colum state
                const col = columnsState.find((c) => c.colId === sortDef.colId);
                if (col) {
                    // Set sort property in the reference
                    col.sort = (_a = sortDef.sort) !== null && _a !== void 0 ? _a : undefined;
                }
            });
            // Set the column state as received but with the sort updated
            this.columnApi.setColumnState(columnsState);
        }
    }
    applyStateUpdateToData(state) {
        if (!state.viewId) {
            return;
        }
        // If client side row model type, set row data to incoming row data
        if (this.rowModelType === 'client-side') {
            // if we are in error state, we will not get data
            const data = state.data || new XpoAgGridBoardData(XpoBoardData.empty(state));
            this.gridApi.setRowData(data.consumerData.rows);
            this.trySelectingFirstRow();
        }
        // If infinite scrolling, create dataSource
        if (this.rowModelType === 'infinite') {
            // If we are in loading state, make sure we clear-out any previous results
            // The next update will return the valid data
            if (state.dataFetchState === XpoBoardDataFetchState.Loading) {
                const emptyDataSet = new XpoAgGridBoardData(XpoBoardData.empty(state));
                this.gridApi.setDatasource(this.createDataAdapter(emptyDataSet));
            }
            else if (state.data) {
                // if startRecord === 0 assume a brand new data set and create new adapter
                if (state.data.startRecord === 0) {
                    this.gridApi.setDatasource(this.createDataAdapter(state.data));
                    this.gridApi.clearFocusedCell();
                }
                else if (state.context) {
                    this.triggerSuccessCallback(state.context, state.data);
                }
            }
            else if (state.dataFetchState === XpoBoardDataFetchState.Error) {
                // make sure we properly tell ag-grid the request failed
                if (state.context) {
                    state.context.failCallback();
                }
                // there might be a better way to do this than simply clear out the data,
                // but while testing, even thought I called failCallback ag-grid still rendered
                // the rows as blank.  So for now if an error occurs do the failure callback
                // and then just completely reset the grid
                const emptyDataSet = new XpoAgGridBoardData(XpoBoardData.empty(state));
                this.gridApi.setDatasource(this.createDataAdapter(emptyDataSet));
            }
        }
        // If totals data, pin totals row to the bottom
        if (state.data && state.data.consumerData.totals) {
            if (state.data.consumerData.totals.length > 0 &&
                state.dataFetchState === XpoBoardDataFetchState.ResultsReturned) {
                this.gridApi.setPinnedBottomRowData(state.data.consumerData.totals);
            }
            else {
                this.gridApi.setPinnedBottomRowData(null);
            }
        }
    }
    generateSortOrderFromState(state) {
        const agColumns = this.columnApi ? this.columnApi.getAllColumns() : [];
        return (state.sortOrder || []).map((orderEl) => {
            const agColumn = agColumns.find((col) => col.getColDef() != null && col.getColDef().field === orderEl.column);
            // The board sort model saves the column field, and this can be different from columnId sometimes
            // So if we can we will pass to ag grid the actual columnId
            return {
                colId: agColumn ? agColumn.getColId() : orderEl.column,
                sort: orderEl.direction,
            };
        });
    }
    /**
     * Returns the sorting from column state as of ag-grid v23+
     */
    getSortModel() {
        return this.columnApi
            .getColumnState()
            .map((c) => ({ colId: c.colId, sort: c.sort }))
            .filter((c) => c.sort);
    }
    generateSortOrderFromSortModel(agGridSortModel) {
        // Build the board data sort model by using colDef.field instead of colId
        // since these can be different sometimes
        return (agGridSortModel || []).map((sortModelCol) => {
            const agColumn = this.columnApi.getColumn(sortModelCol.colId);
            return new XpoSortExpression(agColumn ? agColumn.getColDef().field : sortModelCol.colId, sortModelCol.sort);
        });
    }
    /**
     * Create a onPaginationChanged handler to display pagination in a proper way
     * @returns if isPaginationUpdateForced is true return onPaginationChanged handler
     * to force the pagination update otherwise returns and empty object
     */
    getPaginationUpdateConfig(customGridOptions) {
        if (this.isPaginationUpdateForced) {
            const originalFn = customGridOptions === null || customGridOptions === void 0 ? void 0 : customGridOptions.onPaginationChanged;
            return {
                onPaginationChanged: (data) => {
                    const api = data.api;
                    if (api) {
                        const pageSize = api.paginationGetPageSize();
                        const currentPage = api.paginationGetCurrentPage() + 1;
                        const rowCount = api.paginationGetRowCount();
                        const lastRow = currentPage * pageSize;
                        document.querySelector('[ref="lbLastRowOnPage"]').innerHTML = `${lastRow > rowCount ? rowCount : lastRow}`;
                    }
                    if (originalFn) {
                        originalFn(data);
                    }
                },
            };
        }
        return {};
    }
    initializeGridOptions() {
        // TODO: update when data source changes
        this.gridOptions.cacheBlockSize = this.dataSource.pageSize;
        this.gridOptions.onModelUpdated = (event) => this.onModelUpdated(event);
        this.gridOptions.onSelectionChanged = (event) => this.onGridSelectionChanged(event);
        this.gridOptions.onCellClicked = (event) => this.onCellClicked(event);
        this.gridOptions.onSortChanged = () => this.onSortChanged();
        this.gridOptions.onColumnMoved = (event) => this.onColumnMovedEvent(event);
        this.gridOptions.onColumnPinned = (event) => this.onColumnPinnedEvent(event);
        this.gridOptions.onColumnResized = (event) => this.onColumnResizedEvent(event);
        this.gridOptions.paginationPageSize = this.dataSource.pageSize;
        this.gridOptions.rowSelection = this.rowSelection;
        this.gridOptions.groupUseEntireRow = this.groupUseEntireRow;
        this.gridOptions.suppressMovableColumns = !this.enableMovableColumns;
        this.gridOptions.suppressRowClickSelection = this.selectionMode === 'row' ? false : !this.enableRowSelection;
        this.gridOptions.suppressCellSelection = this.selectionMode === 'cell' ? false : !this.enableCellSelection;
        this.gridOptions.defaultColDef = { sortable: this.enableSorting };
        this.gridOptions.frameworkComponents = this.frameworkComponents;
        this.gridOptions.onGridReady = (event) => this.onGridReady(event);
        this.configureRowModelType();
        this.configurePostSorting();
        this.configureCustomGridStyles();
        if (this.customGridOptions && this.customGridOptions.onGridReady) {
            console.error('XpoAgGridBoard: customGridOptions.onGridReady cannot be used, please listen to the (gridBoardReady) event');
        }
        const mergedOptions = merge.all([
            this.gridOptions,
            this.globalAgGridOptions || {},
            this.customGridOptions || {},
            this.getPaginationUpdateConfig(this.customGridOptions),
        ]);
        this.gridOptions = mergedOptions;
    }
    onColumnResizedEvent(event) {
        // The action we want to perform with the column to be updated
        const updateWidthAction = (colDef, column) => {
            colDef.width = column.getActualWidth() || column.getMinWidth();
        };
        // The event.finished is true after they detect the user stops the movements
        // otherwise the onColumnResizedEvent is fired after each px change
        if (event.finished) {
            this.updateStateColumns(XpoColumnsHelper.onGeneralColumnEvent(event, updateWidthAction, this.columns));
        }
    }
    onColumnPinnedEvent(event) {
        // The action we want to perform with the column to be updated
        const updatePinnedAction = (colDef) => {
            colDef.pinned = event.pinned;
        };
        this.updateStateColumns(XpoColumnsHelper.onGeneralColumnEvent(event, updatePinnedAction, this.columns));
    }
    onColumnMovedEvent(event) {
        this.updateStateColumns(XpoColumnsHelper.onColumnMovedEvent(event, this.columns));
    }
    /**
     * Post sorting actions
     * initializePostSorting
     */
    configurePostSorting() {
        /* Perform a cell refresh after sorting preserving postSort defined by developers in their app.
          This is needed to keep row index in sync when sorting or filtering is applied. */
        if (!this.customGridOptions) {
            return;
        }
        const userDefinedPostSort = this.customGridOptions.postSort;
        this.customGridOptions.postSort = (e) => {
            this.gridOptions.api.refreshCells();
            if (userDefinedPostSort instanceof Function) {
                userDefinedPostSort(e);
            }
        };
    }
    /**
     * Configures row model type and sorting configurations baed on the inputted row model type,
     * defaults to infinite
     */
    configureRowModelType() {
        if (this.rowModelType !== 'client-side') {
            this.gridOptions.rowModelType = this.rowModelType;
        }
        this.stateChange$.next({
            rowModelType: this.rowModelType,
            source: XpoBoardStateSources.RowModelType,
        });
    }
    configureGridColumns() {
        if (!this.columns.length && !this.columnsFromDataSource.length) {
            return;
        }
        // Confirm all the columns have a col id defined or assign one to each
        this.columns = XpoColumnsHelper.addIdsToColumns(this.columns);
        /**
         * Every time columns change evaluate if custom select is needed because this
         * component is not being restarted when you change between grids
         * And you need to keep it updated to prevent errors
         */
        this.checkAddingPaginatedSelectAll();
        /**
         * Reset columns since when switching from a previous view with same colIDs, ag-grid incorrectly stores the old
         * columns as they comment in: https://github.com/ag-grid/ag-grid/blob/0ab1a8ae3d313b3587ee6fb22344ce7f80a31c79/
         * community-modules/core/src/ts/columnController/columnController.ts#L198 and then try to assign unique ids to
         * cols causing wrong col names like status_1 (_1 as the unique part), in deed, causing filters to fail.
         * This is just to have a workaround from our side to something that ag-grid has not properly addressed yet.
         */
        this.gridApi.setColumnDefs([...this.columns, ...this.columnsFromDataSource]);
    }
    /**
     * State change with the current selection on client-side
     * @param event
     */
    onGridSelectionChanged(event) {
        // TODO: Move all hardcoded "client-side" strings into enums
        if (!this.columns) {
            return;
        }
        // Fire SelectionChange only if not using our custom select-all (that also fires selection change)
        if (!this.isUsingCustomSelectAllColumn()) {
            const selectedNodes = event.api.getSelectedNodes() || [];
            const selection = selectedNodes.map((node) => node.data);
            this.stateChange$.next({
                selection,
                source: XpoBoardStateSources.SelectionChange,
            });
        }
    }
    /**
     * Determine whether if user is using our custom select-all column or not
     */
    isUsingCustomSelectAllColumn() {
        return this.columns.some((c) => {
            return c.headerComponentFramework && c.headerComponentFramework.name === XpoAgGridSelectAllCheckbox.name;
        });
    }
    /**
     * If headerCheckboxSelection is declared on a column in an infinite scroll ag-grid,
     * add our custom select all component since ag-grid doesn't support this feature;
     * Else remove our custom select all to prevent duplication with the ag-grid one.
     */
    checkAddingPaginatedSelectAll(columns = this.columns, isDetailGrid = false) {
        const checkboxSelectionColumn = columns.find((c) => c.checkboxSelection);
        if (checkboxSelectionColumn && checkboxSelectionColumn.headerCheckboxSelection) {
            updateFrameworkAndParams(XpoAgGridSelectAllCheckbox, {
                keyField: isDetailGrid ? this.cachedState.template.detailGridKeyField : this.cachedState.template.keyField,
                isDetailGrid,
                rowGroupingSelectable: true,
            });
        }
        function updateFrameworkAndParams(framework, params) {
            checkboxSelectionColumn.headerComponentFramework = framework;
            checkboxSelectionColumn.headerComponentParams = params;
        }
    }
    /**
     * Configure classes and styles we need to use preserving project level defined ones
     */
    configureCustomGridStyles() {
        const ACCORDION_GROUP_OFFSET = this.customGridOptions.groupSelectsChildren ? 30 : 0;
        this.customGridOptions = this.customGridOptions || {};
        // Merge project level rowClassRules with ours
        this.customGridOptions.rowClassRules = Object.assign(Object.assign({}, this.customGridOptions.rowClassRules), {
            // This class is used for accordion and grouping related features
            'xpo-RowGroup': (params) => {
                return params.node && params.node.group;
            },
            'xpo-RowGroup-Checkbox': (params) => {
                return this.customGridOptions.groupSelectsChildren && params.node && params.node.group;
            },
        });
        // Define autoGroupColumnDef in case user never defined it
        this.customGridOptions.autoGroupColumnDef = this.customGridOptions.autoGroupColumnDef || {};
        // Preserve user cellStyle
        const userCellStyles = this.customGridOptions.autoGroupColumnDef.cellStyle;
        this.customGridOptions.autoGroupColumnDef.cellStyle = (params) => {
            let customStyles = {};
            /* Grouping node to left, that's in case rowIndex, SelectAll or Transpose is present
             */
            if (params.node.group) {
                customStyles = {
                    left: `${ACCORDION_GROUP_OFFSET}px`,
                };
            }
            // cellStyle can either be a callable function or an object with the styles
            const userDefinedStyles = typeof userCellStyles === 'function' ? userCellStyles(params) : userCellStyles;
            // Take developer defined styles and merge them with ours
            customStyles = Object.assign(Object.assign({}, customStyles), userDefinedStyles);
            return customStyles;
        };
    }
    createDataAdapter(initialBoardData) {
        const self = this;
        return {
            getRows(params) {
                if (params.startRow > 0 || self.pendingSortApply) {
                    // If self.pagination means user enabled our custom pagination so we ask for the page number to it,
                    // otherwise fallback to current infinite scroll pagination logic.
                    const pageNumber = self.pagination
                        ? self.pagination.currentPage
                        : Math.max(params.startRow / self.dataSource.pageSize + 1, 1);
                    const sortOrder = self.generateSortOrderFromSortModel(params.sortModel);
                    const source = self.pendingSortApply ? XpoBoardStateSources.SortChange : XpoBoardStateSources.PageChange;
                    self.stateChange$.next({ pageNumber, context: params, source, sortOrder });
                    self.pendingSortApply = false;
                }
                else {
                    self.triggerSuccessCallback(params, initialBoardData);
                    self.trySelectingFirstRow();
                }
                const inComingFilters = !isEmpty(params.filterModel) && Object.keys(params.filterModel).length;
                const filtersChanged = !isEqual(params.filterModel, self.cachedAgGridFilterModel);
                /*
                  Filter changed means we need to merge criteria again. We were previously also checking if there was
                  in-coming filters (inComingFilters && filtersChanged) but when clearing filters inComingFilters is
                  of course false but criteria needs to be updated in that scenario too since filters changed.
                */
                if ((inComingFilters && filtersChanged) ||
                    (!Object.keys(params.filterModel).length && !!Object.keys(self.cachedAgGridFilterModel).length)) {
                    const mergedCriteria = self.mergeCriteriaWithFilterModel(params.filterModel);
                    // mergedCriteria = self.checkEqualCriteriaAllSelected(mergedCriteria, self);
                    // self.cachedAgGridFilterModel = params.filterModel;
                    self.filtersService.setCriteria(mergedCriteria);
                }
                // If the filterModel is empty then just update the self cached filter model.
                // If the filter model is empty then FILTER-CHANGE event will update the filterCriteria in filterService.
                // This will trigger only when user is trying to clear the last input filter while the previous filter is exists
                // if (!Object.keys(params.filterModel).length && !!Object.keys(self.cachedAgGridFilterModel).length) {
                //   self.filtersService.setCriteria(params.filterModel);
                //   self.cachedAgGridFilterModel = params.filterModel;
                // }
            },
        };
    }
    /**
     * Check if merged equal conditions are all selected and set correct diplay
     */
    checkEqualCriteriaAllSelected(mergedCriteria, self) {
        const mergedCriteriaClone = cloneDeep(mergedCriteria);
        Object.keys(mergedCriteriaClone).forEach((criteria) => {
            var _a;
            const filterFromModel = self.gridApi.getFilterModel();
            const filterCriteria = (_a = filterFromModel[criteria]) === null || _a === void 0 ? void 0 : _a.filter;
            if (filterCriteria === null || filterCriteria === void 0 ? void 0 : filterCriteria.conditions) {
                filterCriteria.conditions.forEach((conditions) => {
                    if (conditions.display === 'all' && conditions.operator === Operators.Equals) {
                        mergedCriteriaClone[criteria].conditions.forEach((criteriaCondition) => {
                            if (criteriaCondition.operator === Operators.Equals) {
                                criteriaCondition.display = 'all';
                            }
                            return criteriaCondition;
                        });
                    }
                });
            }
        });
        return mergedCriteriaClone;
    }
    triggerSuccessCallback(params, data) {
        const hideRecordCountFromAgGrid = this.suppressUsingRecordCount && params.endRow <= data.recordCount;
        const recordCount = hideRecordCountFromAgGrid ? null : data.recordCount;
        params.successCallback(data.consumerData.rows, recordCount);
    }
    updateStateColumns(newColumns) {
        if (newColumns) {
            this.columns = newColumns;
            this.stateChange$.next({
                visibleColumns: this.columns,
                source: 'SET-VISIBLE-COLUMNS',
            });
        }
    }
    trySelectingFirstRow() {
        if (this.autoSelectFirstRow) {
            const firstRow = this.gridOptions.api.getDisplayedRowAtIndex(0);
            if (firstRow) {
                firstRow.setSelected(true);
            }
        }
    }
    registerBoardApiHandlers() {
        this.agGridBoardApiDispatcher.registerHandler(XpoAgGridBoardApiAction.FocusRow, this.focusRow.bind(this));
        this.agGridBoardApiDispatcher.registerHandler(XpoAgGridBoardApiAction.UpdateEditingState, this.updateEditingState.bind(this));
    }
    focusRow(rowSelection) {
        const viewTemplate = this.cachedState.template;
        const viewTemplateKey = viewTemplate ? viewTemplate.keyField : null;
        if (!viewTemplateKey) {
            // TODO: this should throw an error, but we will need to call the error callback for ag-grid
            // if you throw an error here, pagingation is broken
            console.error(`View template ${viewTemplate.name} has a null keyField value.
        Please provide the key of the field that uniquely identifies each row for this viewTemplate
        in order for some functionality of the ag-grid-board to work`);
            return;
        }
        this.gridApi.clearFocusedCell();
        const gridColumns = this.gridOptions.columnApi.getAllColumns().reverse();
        this.gridApi.forEachNode((node) => {
            if (node.data && rowSelection[viewTemplateKey] === node.data[viewTemplateKey]) {
                // focus all cells from row
                gridColumns.forEach((column) => {
                    this.gridApi.setFocusedCell(node.rowIndex, column.getColId());
                });
                // scroll the grid to see the current node
                this.gridApi.ensureNodeVisible(node, null);
                return;
            }
        });
    }
    applyRowHeightUpdate(state) {
        if (!this.gridApi || !this.isGridReady) {
            return;
        }
        if (this.rowModelType === 'client-side') {
            this.rowHeight = state.rowHeight;
        }
        else {
            // Infinite scroll does not support changing the row heights
            // Ag-grid logic is calculating the virtual view size only once, in their AfterViewInit logic
            // So our only option is to re-create the entire grid all together with the new row height
            // Maybe a future ag-grid version will allow this, and we could delete all these expensive operations
            // Destroy the grid
            this.gridVisible = false;
            this.cd.detectChanges();
            // Reset cached values
            this.cachedState = null;
            this.isGridReady = false;
            this.columns = [];
            this.columnsFromDataSource = [];
            // Re-create the grid with the new height
            this.gridVisible = true;
            this.rowHeight = state.rowHeight;
            this.cd.detectChanges();
            // Reload the data into the new grid
            this.dataSource.refresh();
        }
    }
    loadCriteriaIntoColumnFilters(criteria) {
        // columnApi.getAllGridColumns returns user defined columns and dynamic generated columns like group ones
        const allGridColumns = this.columnApi.getAllGridColumns();
        if (!allGridColumns) {
            return;
        }
        const inlineFilterColumnsFields = allGridColumns.filter((col) => {
            const colDef = col.getColDef();
            return (colDef.field || colDef.colId) && colDef.filter;
        });
        inlineFilterColumnsFields.forEach((col) => {
            const colDef = col.getColDef();
            const filterInstance = this.gridApi.getFilterInstance(colDef.colId || colDef.field);
            if (filterInstance) {
                // If we have a value for this column on criteria, set that one,
                // else just clear out whatever is there (by assigning null)
                // TODO: fix this to work with `not` `exclude` and such.
                const filterModel = (criteria === null || criteria === void 0 ? void 0 : criteria.hasOwnProperty(colDef.field))
                    ? { filter: criteria[colDef.field], type: 'contains' }
                    : null;
                filterInstance.setModel(filterModel);
            }
        });
        if (inlineFilterColumnsFields.length) {
            this.gridApi.onFilterChanged();
        }
    }
    applyColumnFiltersVisibility(filtersVisible) {
        // change floating filters header row visibility only if floating filters are configured by default
        // and if there is some column filter defined
        // otherwise hide floating filters header row
        this.gridOptions.defaultColDef.floatingFilter =
            this.showFloatingFilters && this.hasColumnLevelFilters() ? filtersVisible : false;
        this.gridApi.refreshHeader();
    }
    mergeCriteriaWithFilterModel(agGridFilterModel) {
        // First remove the keys from criteria that were coming from the old filter model
        const strippedCriteria = Object === null || Object === void 0 ? void 0 : Object.keys(this.filtersService.criteria || {}).filter((k) => this.cachedAgGridFilterModel && Object.keys(this.cachedAgGridFilterModel).indexOf(k) === -1).reduce((res, k) => (Object.assign(Object.assign({}, res), { [k]: this.filtersService.criteria[k] })), {});
        // Update the saved filter model
        this.cachedAgGridFilterModel = agGridFilterModel;
        // Map from ag-grid filter model to our own criteria
        // For now this is mapping to simple key-value primitives like {color: 'red'}
        const mappedFilterModel = Object === null || Object === void 0 ? void 0 : Object.keys(agGridFilterModel).reduce((res, field) => (Object.assign(Object.assign({}, res), { [field]: agGridFilterModel[field].filter })), {});
        return Object.assign(Object.assign({}, strippedCriteria), mappedFilterModel);
    }
    addColumnLevelFilters() {
        if (!this.columnFilters || this.columnFilters.length === 0) {
            return;
        }
        const filerColumnPair = this.columnFilters
            .map((filter) => {
            const foundColumn = this.columns.find((c) => c.field && c.filter && c.field === filter.field);
            return foundColumn ? { filter, foundColumn } : undefined;
        })
            .filter((v) => !!v);
        filerColumnPair.forEach((p) => {
            p.foundColumn.filter = true;
            p.foundColumn.floatingFilterComponent = 'xpoAgGridFilterChipComponent';
            p.foundColumn.floatingFilterComponentParams = {
                criteriaStore: this.filtersService,
                filter: p.filter,
                suppressFilterButton: true,
            };
        });
    }
    /**
     * onModelUpdated event listener.
     * If the grid suffer change dispatch this event
     *
     * @param event The event being triggered off of
     */
    onModelUpdated(event) {
        if (!this.gridApi) {
            return;
        }
        const newVisibleRows = this.gridApi.getDisplayedRowCount();
        if (this.isDataAlreadyRendered() && this.cachedState.visibleRows !== newVisibleRows) {
            this.stateChange$.next({
                source: 'update-row-count',
                visibleRows: newVisibleRows,
            });
            // Notify change to pagination
            if (this.pagination) {
                this.pagination.notifyPagination();
            }
        }
        /**
         * Every time the model update is dispatched iterate the detail grids replacing,
         * if exists, the default ag-grid select all component
         * with our custom one.
         */
        this.gridApi.forEachDetailGridInfo((detailGridApi) => {
            const detailGridColumns = detailGridApi.columnApi.getAllColumns().map((c) => c.getColDef());
            this.checkAddingPaginatedSelectAll(detailGridColumns, true);
            detailGridApi.api.refreshHeader();
        });
    }
    isDataAlreadyRendered() {
        if (!this.dataAlreadyRendered) {
            this.dataAlreadyRendered = coerceBooleanProperty(this.cachedState && this.cachedState.data);
        }
        return this.dataAlreadyRendered;
    }
    /**
     * Prepare values to be displayed in applied filters, custom filters
     */
    getCustomFilterValues(colDef, values) {
        const displayValues = [];
        // Conditional enum filter
        if (colDef.filterParams && colDef.filterParams.enumValues) {
            values.forEach((val) => {
                const customValue = colDef.filterParams.enumValues[val] || val;
                displayValues.push(customValue);
            });
        }
        return displayValues;
    }
    updateEditingState(isEditing, field) {
        if (isEditing) {
            this.startEditing(field || '');
        }
        else {
            this.stopEditing();
        }
    }
    startEditing(colKey) {
        this.gridApi.startEditingCell({
            colKey: colKey,
            rowIndex: 0,
        });
    }
    stopEditing() {
        this.gridApi.stopEditing();
    }
    initializeColumnLevelFilteringVisibleState() {
        // preserve the initial value of floating filters available
        // this defaultColDef property could change later when showing or hiding the floating filters row
        // TODO: when update ag-grid package, evaluate this option at colDef level too (NGXLT-372)
        this.showFloatingFilters = this.gridOptions.defaultColDef.floatingFilter;
        // trigger a state update to let board know if the toggle filters button should be visible
        this.stateChange$.next({
            filtersButtonVisible: this.showFloatingFilters,
            source: XpoBoardStateSources.InitializeFloatingFilters,
        });
        // do not show filter button next to floating filter input
        this.gridOptions.defaultColDef.floatingFilterComponentParams = { suppressFilterButton: true };
        // by default, ag-grid shows floating filters header row depending on gridOptions.floatingFilters
        // if we are going to show floating filters
        // trigger a state update so that the XpoColumnLevelFilteringToggleComponent gets this default value
        if (this.showFloatingFilters) {
            const floatingFiltersVisible = this.gridOptions.context && this.gridOptions.context.filtersOptionsVisibleDefaultValue !== undefined
                ? this.gridOptions.context.filtersOptionsVisibleDefaultValue
                : XpoColumnLevelFilteringToggleComponent.IsFilterVisibleDefaultValue;
            this.stateChange$.next({
                columnLevelFilteringVisible: floatingFiltersVisible,
                source: XpoBoardStateSources.InitializeFloatingFilters,
            });
        }
    }
    hasColumnLevelFilters() {
        // find at lease one column with a filter defined
        const allColumns = this.columnApi.getAllColumns();
        return allColumns ? allColumns.some((col) => col.isVisible && col.isFilterAllowed) : false;
    }
}
XpoAgGridBoard.ɵfac = function XpoAgGridBoard_Factory(t) { return new (t || XpoAgGridBoard)(i0.ɵɵdirectiveInject(i1.XpoBoardDataSourceResolver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(XpoAgGridBoardApiDispatcherService), i0.ɵɵdirectiveInject(i1.XpoFiltersService), i0.ɵɵdirectiveInject(XPO_BOARD_AG_GRID_DEFAULT_GRID_OPTIONS, 8)); };
XpoAgGridBoard.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAgGridBoard, selectors: [["xpo-ag-grid-board"]], hostAttrs: [1, "xpo-AgGridBoard"], inputs: { autoSelectFirstRow: "autoSelectFirstRow", autoSizeColumns: "autoSizeColumns", enableMovableColumns: "enableMovableColumns", enableCellSelection: "enableCellSelection", enableRowSelection: "enableRowSelection", enableSorting: "enableSorting", groupUseEntireRow: "groupUseEntireRow", sizeColumnsToFit: "sizeColumnsToFit", customGridOptions: "customGridOptions", rowSelection: "rowSelection", rowModelType: "rowModelType", selectionMode: "selectionMode", suppressUsingRecordCount: "suppressUsingRecordCount", columnFilters: "columnFilters", pagination: "pagination", paginationPageSizes: "paginationPageSizes", paginationPageSizeStart: "paginationPageSizeStart", highlightMode: "highlightMode", isPaginationUpdateForced: "isPaginationUpdateForced" }, outputs: { cellSelected: "cellSelected", gridReady: "gridReady", gridBoardReady: "gridBoardReady", refreshPagination: "refreshPagination" }, features: [i0.ɵɵProvidersFeature([XpoAgGridBoardApiDispatcherService]), i0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["data-cy", "xpo-ag-grid", 3, "ngClass", "rowHeight", "autoSizeColumns", "sizeColumnsToFit", "selectionMode", 4, "ngIf"], ["data-cy", "xpo-ag-grid", 3, "ngClass", "rowHeight", "autoSizeColumns", "sizeColumnsToFit", "selectionMode"], [3, "gridOptions"]], template: function XpoAgGridBoard_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoAgGridBoard_xpo_ag_grid_0_Template, 2, 6, "xpo-ag-grid", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.gridVisible);
    } }, directives: [i3.NgIf, i4.XpoAgGridComponent, i3.NgClass, i5.AgGridAngular], styles: [".flex--stretch{flex:1}.xpo-AgGridBoard{display:flex;flex-direction:column;height:100%}.xpo-AgGridBoard *:focus{outline:none}.xpo-AgGridBoard .xpo-AgGrid .ag-overlay-wrapper.ag-overlay-loading-wrapper,.xpo-AgGridBoard .xpo-AgGrid .ag-overlay-wrapper.ag-overlay-no-rows-wrapper{display:none}.xpo-AgGridBoard .xpo-AgGrid .ag-input-wrapper>input.ag-floating-filter-input{background-color:#fff}.xpo-AgGridBoard .xpo-AgGrid .ag-floating-filter-full-body .xpo-FilterChip{height:20px}.xpo-AgGridBoard .xpo-AgGrid .ag-floating-filter-full-body .xpo-FilterChip-dropdownTrigger{height:100%}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .ag-icon-filter:before{display:none}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .ag-header-icon{display:flex}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .ag-menu .ag-tabs-header{display:none}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .ag-row-focus:not(.xpo-RowGroup) .ag-cell:last-child{border-right:1px solid #d8d8d8}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .xpo-AgGrid-checkboxColumn .ag-cell-wrapper{justify-content:center}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-group-expanded,.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-group-contracted{align-items:center;color:#000;display:flex;margin-right:8px}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.xpo-RowGroup .xpo-AgGrid-rowIndexColumn,.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.xpo-RowGroup .xpo-AgGrid-transposeColumn{display:none}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.xpo-RowGroup:not(.xpo-RowGroup-Checkbox) .xpo-AgGrid-checkboxColumn{display:none}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.xpo-RowGroup-Checkbox .xpo-AgGrid-checkboxColumn{background:none;border-right:none}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group.ag-row-level-0{align-items:center;font-size:1.143rem;font-weight:500;text-transform:capitalize}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn){background:none;border-color:transparent;overflow:visible}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn):hover{background-color:transparent!important}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn) .ag-group-value{overflow:visible}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn).xpo-AgGrid-editableCell{background-color:#fff9c4}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn).xpo-AgGrid-editableCell--error:not(.xpo-AgGrid-rowIndexColumn):not(.xpo-AgGrid-checkboxColumn){background-color:#fceeeb}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn).xpo-AgGrid-editableCell--error:not(.xpo-AgGrid-rowIndexColumn):not(.xpo-AgGrid-checkboxColumn):hover{background-color:#fceeeb}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn).xpo-AgGrid-editableCell:hover,.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .ag-cell:not(.xpo-AgGrid-checkboxColumn).xpo-AgGrid-editableCell:focus{background-color:#fff9c4}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group.xpo-AgGrid-accordion:not(.ag-row-level-0) .ag-cell{border-right-color:#d8d8d8}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .xpo-AgGrid-checkboxColumn{border-right-color:#d8d8d8}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion.ag-row-group .xpo-aggregationCell{font-size:.875rem}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-row-group-indent-0{align-items:center;padding-left:5px}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-cell-wrapper{justify-content:flex-start;margin-left:0}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-cell-wrapper.ag-row-group-indent-1{padding-left:0}.xpo-AgGridBoard .xpo-AgGrid.ag-theme-material .xpo-AgGrid-accordion .ag-cell .ag-row-group-indent-0{padding-left:0}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAgGridBoard, [{
        type: Component,
        args: [{
                selector: 'xpo-ag-grid-board',
                templateUrl: './ag-grid-board.component.html',
                styleUrls: ['./ag-grid-board.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-AgGridBoard' },
                providers: [XpoAgGridBoardApiDispatcherService],
            }]
    }], function () { return [{ type: i1.XpoBoardDataSourceResolver }, { type: i0.ChangeDetectorRef }, { type: XpoAgGridBoardApiDispatcherService }, { type: i1.XpoFiltersService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [XPO_BOARD_AG_GRID_DEFAULT_GRID_OPTIONS]
            }] }]; }, { autoSelectFirstRow: [{
            type: Input
        }], autoSizeColumns: [{
            type: Input
        }], enableMovableColumns: [{
            type: Input
        }], enableCellSelection: [{
            type: Input
        }], enableRowSelection: [{
            type: Input
        }], enableSorting: [{
            type: Input
        }], groupUseEntireRow: [{
            type: Input
        }], sizeColumnsToFit: [{
            type: Input
        }], customGridOptions: [{
            type: Input
        }], rowSelection: [{
            type: Input
        }], rowModelType: [{
            type: Input
        }], selectionMode: [{
            type: Input
        }], suppressUsingRecordCount: [{
            type: Input
        }], columnFilters: [{
            type: Input
        }], cellSelected: [{
            type: Output
        }], gridReady: [{
            type: Output
        }], gridBoardReady: [{
            type: Output
        }], refreshPagination: [{
            type: Output
        }], pagination: [{
            type: Input
        }], paginationPageSizes: [{
            type: Input
        }], paginationPageSizeStart: [{
            type: Input
        }], highlightMode: [{
            type: Input
        }], isPaginationUpdateForced: [{
            type: Input
        }] }); })();

class XpoAgGridBoardModule {
}
XpoAgGridBoardModule.ɵfac = function XpoAgGridBoardModule_Factory(t) { return new (t || XpoAgGridBoardModule)(); };
XpoAgGridBoardModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoAgGridBoardModule });
XpoAgGridBoardModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [{ provide: XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, useValue: XPO_AG_GRID_DEFAULT_ROW_HEIGHT }], imports: [[
            AgGridModule.withComponents([XpoAgGridFilterChipComponent, XpoAgGridSelectAllCheckbox]),
            CommonModule,
            MatButtonModule,
            XpoButtonModule,
            MatProgressSpinnerModule,
            XpoAgGridModule,
            XpoFiltersModule,
            MatCheckboxModule,
            FormsModule,
        ], XpoBoardModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAgGridBoardModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoAgGridBoard, XpoAgGridFilterChipComponent, XpoAgGridSelectAllCheckbox],
                imports: [
                    AgGridModule.withComponents([XpoAgGridFilterChipComponent, XpoAgGridSelectAllCheckbox]),
                    CommonModule,
                    MatButtonModule,
                    XpoButtonModule,
                    MatProgressSpinnerModule,
                    XpoAgGridModule,
                    XpoFiltersModule,
                    MatCheckboxModule,
                    FormsModule,
                ],
                exports: [XpoAgGridBoard, XpoBoardModule],
                // TODO: use factory to check if XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT already is provided, if not, use this default
                // To enable end dev to default their own row height
                providers: [{ provide: XPO_GRID_BOARD_DEFAULT_ROW_HEIGHT, useValue: XPO_AG_GRID_DEFAULT_ROW_HEIGHT }],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoAgGridBoardModule, { declarations: [XpoAgGridBoard, XpoAgGridFilterChipComponent, XpoAgGridSelectAllCheckbox], imports: [i5.AgGridModule, CommonModule,
        MatButtonModule,
        XpoButtonModule,
        MatProgressSpinnerModule,
        XpoAgGridModule,
        XpoFiltersModule,
        MatCheckboxModule,
        FormsModule], exports: [XpoAgGridBoard, XpoBoardModule] }); })();

/*
 * Public API Surface of ngx-ltl-board-grid
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GridDataReplayCache, XPO_BOARD_AG_GRID_DEFAULT_GRID_OPTIONS, XpoAgGridBoard, XpoAgGridBoardApi, XpoAgGridBoardApiAction, XpoAgGridBoardApiDispatcherService, XpoAgGridBoardData, XpoAgGridBoardDatum, XpoAgGridBoardModule, XpoAgGridBoardReadyEvent, XpoAgGridBoardView, XpoAgGridBoardViewTemplate, XpoAgGridFilterChipComponent, XpoAgGridSelectAllCheckbox };
